module.exports = __WEBPACK_EXTERNAL_MODULE_99__;


//////////////////
// WEBPACK FOOTER
// external "vue-cookie"
// module id = 99
// module chunks = 0 2